module.exports = __webpack_public_path__ + "static/media/menu.c7a33222.gif";